import { usePlatformPresence } from '../hooks/usePlatformPresence';

const PlatformPresenceTracker = () => {
  usePlatformPresence();
  return null;
};

export default PlatformPresenceTracker;
